export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20theater%20interior%20with%20dramatic%20golden%20and%20crimson%20red%20spotlights%2C%20elegant%20velvet%20curtains%2C%20premium%20atmosphere%2C%20grand%20stage%20lighting%2C%20warm%20metallic%20accents%2C%20cinematic%20composition%2C%20rich%20textures&width=1800&height=700&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2
          className="text-2xl md:text-4xl font-bold text-white mb-4"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          准备好开始了吗？
        </h2>
        <p className="text-white/70 text-sm md:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          立即注册大满贯，即享专属欢迎福利。安全、公平、丰富的游戏体验等你来发现！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-white px-10 py-4 rounded-full text-base font-bold transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            免费注册 · 领取礼包
          </a>
          <a
            href="#"
            className="w-full sm:w-auto border border-white/30 hover:border-white/60 text-white px-10 py-4 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            联系客服
          </a>
        </div>
      </div>
    </section>
  );
}